import React from 'react';
import { Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { ColorPalette } from '../config/color-palette';
import { Tooltip } from '../tooltip';

export interface ILaunchBoxButtonProps {
  buttonText: string;
  icon: IconDefinition;
  onClick: () => void;
  disabled?: boolean;
  testId?: string;
  tooltipText?: string;
}

export interface ILaunchBoxProps {
  children?: any;
}
const useStyles = makeStyles()(() =>
  ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    icon: {
      alignItems: 'center',
      backgroundColor: ColorPalette.CityNightSkiesDark,
      color: ColorPalette.WHITE,
      display: 'flex',
      flex: '0 0 45px',
      fontSize: '1.3rem',
      height: 45,
      justifyContent: 'center',
      marginRight: 10,
      width: 45,
    },
    iconDisabled: {
      backgroundColor: '#3e67796e',
    },
    item: {
      alignItems: 'center',
      borderTop: '1px solid #dedede',
      display: 'flex',
      minWidth: 100,
      width: '100%',
      '&:first-child': {
        borderTop: 'none',
      },
    },
    buttonWrapper: {
      display: 'flex',
      width: '100%',
    },
    button: {
      display: 'flex',
      fontWeight: 500,
      justifyContent: 'flex-start',
      padding: 0,
      textTransform: 'none',
      width: '100%',
      lineHeight: 1.25,
      '&>span': {
        flex: '1 1 auto',
      },
    },
  })
);

export function LaunchBoxButton(props: ILaunchBoxButtonProps) {
  const { onClick, icon, buttonText, disabled = false, tooltipText = '' } = props;
  const { classes } = useStyles();

  return (
    <div className={classes.item}>
      <Tooltip title={tooltipText}>
        <span className={classes.buttonWrapper}>
          <Button onClick={onClick} className={classes.button} disabled={disabled}>
            <div className={classes.icon}>
              <FontAwesomeIcon icon={icon} size="1x" />
            </div>
            {buttonText}
          </Button>
        </span>
      </Tooltip>
    </div>
  );
}

export function LaunchBox(props: ILaunchBoxProps) {
  const { children } = props;
  const { classes } = useStyles();

  return <div className={classes.container}>{children}</div>;
}
